import { JLPTLevel } from './types';

/**
 * JLPT 等级详细描述
 */
export const JLPT_LEVEL_DESCRIPTIONS: Record<
  JLPTLevel,
  {
    name: string;
    nameJa: string;
    description: string;
    canDo: string[];
    studyHours: string;
  }
> = {
  [JLPTLevel.N5]: {
    name: '初级入门',
    nameJa: '初級',
    description: '能够理解基本的日语。可以阅读和理解使用平假名、片假名和基本汉字的典型短语和句子。',
    canDo: [
      '阅读和理解用平假名、片假名和基本汉字书写的典型短语和句子',
      '听取日常生活中常见场景的对话，理解必要信息',
    ],
    studyHours: '约 300-450 小时',
  },
  [JLPTLevel.N4]: {
    name: '初级',
    nameJa: '初級',
    description: '能够理解日常日语的基本水平。可以阅读和理解涉及日常话题的用基本词汇和汉字书写的文章。',
    canDo: [
      '阅读和理解日常话题的基本文章',
      '听取日常生活中较慢的对话，理解大致内容',
    ],
    studyHours: '约 600-750 小时',
  },
  [JLPTLevel.N3]: {
    name: '中级',
    nameJa: '中級',
    description: '能够在一定程度上理解日常生活中使用的日语。可以阅读和理解涉及日常话题的报纸标题等。',
    canDo: [
      '阅读和理解日常话题的书面材料',
      '听取日常对话，理解大意和具体信息',
      '理解口语和书面语之间的表达差异',
    ],
    studyHours: '约 950-1200 小时',
  },
  [JLPTLevel.N2]: {
    name: '中高级',
    nameJa: '中上級',
    description: '能够理解日常场景中使用的日语，以及在一定程度上理解各种场景中使用的日语。',
    canDo: [
      '阅读和理解报纸、杂志等涉及广泛话题的文章',
      '听取各类场景中接近正常语速的对话和新闻，理解大意',
    ],
    studyHours: '约 1700-2200 小时',
  },
  [JLPTLevel.N1]: {
    name: '高级',
    nameJa: '上級',
    description: '能够理解各种场景中使用的日语。可以阅读逻辑复杂或抽象性较高的文章，理解其结构。',
    canDo: [
      '广泛阅读各种题材的文章，理解深层含义',
      '听取各类场景中以正常语速进行的对话、新闻、讲座',
      '理解细节和说话者的意图',
    ],
    studyHours: '约 3000+ 小时',
  },
};

/**
 * 获取等级描述
 */
export function getLevelDescription(level: JLPTLevel) {
  return JLPT_LEVEL_DESCRIPTIONS[level];
}

/**
 * 获取下一个等级
 */
export function getNextLevel(currentLevel: JLPTLevel): JLPTLevel | null {
  const levels = Object.values(JLPTLevel);
  const currentIndex = levels.indexOf(currentLevel);
  if (currentIndex > 0) {
    return levels[currentIndex - 1]; // N5 is last in array, N1 is first
  }
  return null;
}

/**
 * 比较两个等级
 * 返回 -1 如果 a < b，0 如果 a = b，1 如果 a > b
 * N5 < N4 < N3 < N2 < N1
 */
export function compareLevels(a: JLPTLevel, b: JLPTLevel): number {
  const levels = Object.values(JLPTLevel);
  const indexA = levels.indexOf(a);
  const indexB = levels.indexOf(b);
  return Math.sign(indexA - indexB); // N1 (high index) > N5 (low index)
}
